import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Correct way to import ReactDOM in React 18+
import App from "./App";
import "./index.css";

const root = document.getElementById("root");

if (root) {
  const reactRoot = ReactDOM.createRoot(root); // ✅ Use createRoot() instead of render()
  reactRoot.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("No root element found. Check your index.html file.");
}